// Spanish translations for src/config/release-notes.md.
// See release-notes.fr.ts for the schema.

export const releaseNotesEs: Record<string, string> = {
  '0.2.0': `### 0.2.0 — Artefactos

Una nueva mecánica de juego avanzado cuyos pros y contras el jugador debe sopesar con cuidado.

- **Introducción de los Artefactos** — soltados por los jefes tras la Ascensión 5, con más líneas de modificadores a niveles de jefe más altos. Cada artefacto lleva un modificador positivo y uno negativo — sopésalos antes de equiparlos.
- **Mejor progresión inactiva** — mejor gestión de fotogramas para evitar picos de daño y curación que podían causar muertes inesperadas
- **Nunca terminado** — muchas pequeñas correcciones de errores y mejoras de interfaz`,
}
